import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCode,
  faBars,
  faXmark,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

const Navbar = () => {
  const [toggle, setToggle] = useState(true);

  return (
    <div className="font-mono shadow-2xl shadow-blue-500/20 fixed top-0 z-20 flex w-full p-5 text-slate-50 justify-between flex-row w-full h-[100px] bg-gradient-to-b from-gray-900 to-gray-600 bg-gradient-to-r border-2">
      <div className="flex items-center ml-10 cursor-pointer hover:scale-105 transition ease-in-out duration-300">
        <FontAwesomeIcon
          className="text-white mr-3 text-[20px]"
          icon={faCode}
        />
        <h1 className="text-[20px] font-bold sm:text-[25px]">
          Rajwardhan Shinde
        </h1>
      </div>
      <div className="grid items-center mr-10 font-medium text-white">
        <ul className="sm:flex list-none hidden justify-end">
          <li className="mr-7 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            <a href="#skills">Skills</a>
          </li>
          <li className="mr-7 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            <a href="#projects">Projects</a>
          </li>
          <li className="mr-7 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            <a
              href={require("./assets/Rajwardhan_Resume.pdf")}
              download="Rajwardhan_Resume"
            >
              Resume
              <FontAwesomeIcon icon={faDownload} className="ml-[10px]" />
            </a>
          </li>
        </ul>
      </div>
      <div className="sm:hidden flex items-center">
        <FontAwesomeIcon
          className="w-[28px] h-[28px]"
          icon={toggle ? faBars : faXmark}
          onClick={() => setToggle((prev) => !prev)}
        />
        <ul
          className={`${
            toggle ? "hidden" : "flex"
          } flex-col absolute right-1 top-20 bg-slate-500 rounded-xl p-5 list-none justify-end border-2 border-slate-200 shadow-xl`}
        >
          <li className="mr-5 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            Skills
          </li>
          <li className="mr-5 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            Projects
          </li>
          <li className="mr-5 cursor-pointer transition ease-in-out duration-300 hover:font-bold hover:scale-110 text-[20px]">
            Resume
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
